import { BranchUpdateAdapter } from '../../../../adapter';

export default async function BranchUpdateUseCase(event) {
    const { BRANCH_ID, BRANCH_NAME, BRANCH_ADDRESS, PCC, PCC_NAME, PARENT_BRANCH_ID, IS_SUB_BRANCH } = event;

    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/branch/update';

    const payload = {
        data: {
            branchData: {
                id: BRANCH_ID,
                branch_name: BRANCH_NAME,
                branch_address: BRANCH_ADDRESS,
                pcc: PCC,
                pcc_name: PCC_NAME,
                parent_branch_id: PARENT_BRANCH_ID,
                is_sub_branch: IS_SUB_BRANCH
            },
            signature: ''
        }
    };

    const result = await BranchUpdateAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
